(function() {
    'use strict';

    angular.module('product')
        .controller('CategoryListController', CategoryListController);

    CategoryListController.$inject = ['$state', '$scope', 'categoryDataSrvc', 'categorySrvc', 'notificationSrvc', 'categoryMessagesConst', 'lodashService', 'datatableDefaultPageSizeValueConst', 'searchFilterSrvc', 'checkSearchSrvc', 'categoryPermissionsConst', 'redirectOutsideSrvc', 'filterQuerySrvc'];

    function CategoryListController($state, $scope, categoryDataSrvc, categorySrvc, notificationSrvc, categoryMessagesConst, lodashService, datatableDefaultPageSizeValueConst, searchFilterSrvc, checkSearchSrvc, categoryPermissionsConst, redirectOutsideSrvc, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.categoryRows = [];
        self.categoryCols = [{
            title: 'Obraz',
            value: 'image',
            type: 'image'
        }, {
            title: 'Nazwa',
            value: 'title',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Kategoria nadrzędna',
            value: 'parent',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Aktywna',
            value: 'is_published',
            type: 'boolean',
            searchable: true,
            orderable: true
        }];
        self.modelPermissions = categoryPermissionsConst;

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.searchQuery = {
            title: null,
            description: null,
            parent: null,
            is_published: true,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;
        self.onReorder = onReorder;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;
        self.cleanFilters = cleanFilters;

        self.extraActions = [{
            class: 'btn btn-xs',
            iconClass: 'flag flag-pl',
            onClick: redirectPublicPl,
            isDisabled: isRedirectPublicDisabledPl,
            title: 'Sklep Polski'
        }, {
            class: 'btn btn-xs',
            iconClass: 'flag flag-de',
            onClick: redirectPublicDe,
            isDisabled: isRedirectPublicDisabledDe,
            title: 'Sklep Niemiecki'
        }];

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getCategories();
        }

        function getCategories(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    title: self.searchQuery.title,
                    description: self.searchQuery.description,
                    parent: self.searchQuery.parent,
                    is_published: searchFilterSrvc.getCheckboxFilterValue(self.searchQuery.is_published),
                    ordering: self.searchQuery.ordering
                };
            }
            return categoryDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.categoryRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getCategories);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.category.create');
        }

        function onEdit(row) {
            $state.go('layout.category.update', { pk: row.pk });
        }

        function onDelete(row) {
            return categorySrvc.remove(row.title, row.pk, function(response) {
                notificationSrvc.notification("success", categoryMessagesConst.delete);
                lodashService.remove(self.categoryRows, { pk: row.pk });
                return response;
            }, function(error) {
                notificationSrvc.notification("error", error.data.detail);
            });
        }

        function onReorder(row, newPos, dragDirection) {

            if(newPos === undefined)
                return false;

            var replacedRowPos = newPos;
            if(dragDirection > 0) {
                replacedRowPos +=  1;
            } else if(dragDirection < 0) {
                replacedRowPos -= 1;
            }

            var replacedRow = self.categoryRows[replacedRowPos];
            var newPosition = replacedRow.position;

            return categoryDataSrvc.update({
                pk: row.pk
            }, {
                position: newPosition
            }).$promise.then(
                function(response) {
                    getCategories();
                    notificationSrvc.notification("success", categoryMessagesConst.positionChanged);
                    return response;
                },
                function(response) {
                    notificationSrvc.notification("error", categoryMessagesConst.error);
                }
            );
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getCategories();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getCategories();
        }

        function redirectPublicPl(category) {
            redirectOutsideSrvc.go(category.absolute_public_pl_url);
        }

        function isRedirectPublicDisabledPl(category) {
            return !category.absolute_public_pl_url;
        }

        function redirectPublicDe(category) {
            redirectOutsideSrvc.go(category.absolute_public_de_url);
        }

        function isRedirectPublicDisabledDe(category) {
            return !category.absolute_public_de_url;
        }

        function cleanFilters() {
            self.searchQuery = {
                title: null,
                description: null,
                parent: null,
                is_published: true,
                ordering: null,
                is_published: null
            };
            $scope.$broadcast('onCleanSearchFilters', {
                searchQuery: self.searchQuery
            })
        }
    }
})();
